import jaLocale from 'element-ui/lib/locale/lang/ja'

const ja = {
	login: {
		Welcome: 'ようこそ',
		correct: '正しいメールアドレスを入力してください',
		enter: 'パスワードを入力してください',
		Sign: 'サインイン',
		Forgot: 'パスワードを忘れた',
		Create: 'アカウントを作成',
		Password: 'パスワードを入力してください',
		Welcome_to_TOZO: 'TOZOへようこそ',
		email: 'メールアドレスを入力してください',
		agree: ' * 同意します',
		Agreement: 'ユーザー契約',
		see: '。私たちの',
		Policy: 'プライバシーポリシー',
		here: ' をご覧ください。',
		Account: 'アカウントを作成',
		account: 'または、ソーシャルアカウントで続行',
		email_placeholder: 'アカウント番号またはメールアドレスを入力してください',
		email_required: 'アカウント番号またはメールアドレスを入力してください',
		email_correct: '正しいメールアドレスを入力してください',
		password_required: 'パスワードを入力してください',
		login_fail: 'ログインに失敗しました',
		error_4000: 'アプリケーション名を空にすることはできません、またはリンクが存在しません',
		error_4006: '申し訳ありませんが、入力した確認コードが間違っています',
		error_4008: '申し訳ありませんが、メールアドレスはすでに登録されています',
		error_4009: '申し訳ありませんが、入力したアカウントは存在しません',
		error_4010: '申し訳ありませんが、入力したアカウントパスワードが間違っています'
	},
	register: {
		register_title: 'アカウントを登録',
		email_placeholder: 'メールアドレスを入力してください',
		code_placeholder: '確認コードを入力してください',
		get: '取得',
		countdownTips: '確認コードは10分間有効です',
		password_placeholder: 'パスワードを入力してください',
		confirm_password_placeholder: '確認パスワードを入力してください',
		regulation: "パスワードは8〜16文字で、数字、文字、記号のうち少なくとも2つの組み合わせを含む必要があります。",
		agree_text1: "私は読み、同意します",
		agree_text2: 'アカウント利用規約、アカウントプライバシー声明',
		register_btn: '登録',
		agree_required: '契約に同意する必要があります',
		password_required: 'パスワードを確認してください',
		confirmed_and_password_correct: '確認したパスワードが最初に入力したパスワードと異なります',
		email_required: 'メールアドレスを入力してください',
		email_correct: 'メールアドレス形式が間違っています',
		code_required: '確認コードを入力してください',
		password_required_js: 'パスワードを入力してください',
		password_correct: 'パスワードの長さは8〜16文字である必要があります',
		registered: 'このメールアドレスはすでに登録されています',
		email_format: 'メールアドレスの形式が間違っています',
		account_required: 'アカウントが必要です',
		email_information: '確認コードが正常に送信されました。メール情報に注意してください',
		register_successfully: 'TOZOアカウントが正常に登録されました'
	},
	reset: {
		reset_title: "パスワードをリセット",
		old_password_placeholder: '古いパスワードを入力してください',
		new_password_placeholder: '新しいパスワードを入力してください',
		password_confirmation: '新しいパスワードを再度入力してください',
		reset_btn: 'リセット',
		reconfirm_new_password: '新しいパスワードを再確認してください',
		new_password_verify: '2回入力された新しいパスワードが新しいパスワードと一致しません',
		password_format: '長さは8〜16文字である必要があります',
		password_changed_successfully: 'パスワードが正常に変更されました'
	},
	forgot: {
		forgot_title: "パスワードを見つける",
		email_placeholder: 'メールアドレスを入力してください',
		code_placeholder: '確認コードを入力してください',
		get: '取得',
		countdownTips: '確認コードは10分間有効です',
		password_placeholder: '新しいパスワードを入力してください',
		confirm_password_placeholder: '新しいパスワードを確認してください',
		submit_btn: '送信',
		password_required: '新しいパスワードを確認してください',
		confirmed_and_password_correct: '確認したパスワードが最初に入力したパスワードと異なります',
		email_required: 'メールアカウントを入力してください',
		email_correct: '正しいメール形式を入力してください',
		code_required: '確認コードを入力してください',
		password_required_js: '新しいパスワードを入力してください',
		password_correct: 'パスワードの長さは8〜16文字である必要があります',
		email_information: '確認コードが正常に送信されました。メール情報に注意してください',
		email_verify: 'メールアドレスを入力してください',
		forgot_successfully: 'パスワードが正常に変更されました'
	},
	page_404: {
		SORRY: "申し訳ありません！",
		reserved: "全著作権所有",
		check_text: "入力したURLが正しいかどうか確認するか、下のボタンをクリックしてホームページに戻ってください。",
		Back_Home: "ホームに戻る",
		Get_Support: "サポートを受ける",
		message: "申し訳ありませんが、このページにアクセスできません..."
	},
	nav_box: {
		title: {
			NEW_RELEASES: "新作",
			HEADPHONES: "ヘッドホン",
			WATCHES: "時計",
			SPEAKERS: "スピーカー",
			HOT_SALE: "ホットセール",
			MID_YEAR_SALE: "年中セール",
			GAME_DEALS: "ゲーム特価",
			HALLOWEEN_SALE: "ハロウィンセール",
			BLACK_FRIDAY: "ブラックフライデー",
			CYBER_MONDAY: "サイバーマンデー",
			DEALS: "お得情報",
			CHRISTMAS_SALE: "クリスマスセール",
			HOLIDAY_SALE: 'ホリデーセール',
			SOUND_DEALS: "サウンドディール",
			VALENTINE_S_DAY: "バレンタインデー",
			TOZO_COUPON: "TOZOクーポン",
			ST_PATRICK_S_DAY: "聖パトリックの日",
			SPRING_SALE: "春のセール",
			EASTER_SALE: "イースターセール",
			EARTH_DAY_SALE: "アースデーセール",
			MOTHERS_DAY_SALE: "母の日セール",
			FATHERS_DAY: "父の日",
			INDEPENDENCE_DAY: "独立記念日",
			PRIME_DAY: "プライムデー",
			SUMMER_SALE: "サマーセール",
			BACK_TO_SCHOOL: "新学期セール",
			NEW_YEAR_SALE: "新年セール",
			SUMMER_DEALS: "夏のセール",
			SUPPORT: "サポート",
			EXPLORE: "探索"
		},
		NEW_RELEASES: {
			Shop_All_New_Releases: "すべての新作を見る"
		},
		HEADPHONES: {
			EARBUDS: "イヤホン",
			OPEN_EAR: "オープンイヤー",
			OVER_EAR: "オーバーイヤー",
			Active_Noise_Cancelling: "アクティブノイズキャンセリング",
			Fitness: "フィットネス",
			Wireless_Charging: "ワイヤレス充電",
			Hi_Res_Audio: "高解像度オーディオ",
			Premium_Call_Quality: "プレミアム通話品質",
			Gaming: "ゲーミング",
			Waterproof_Earbuds: "防水イヤホン",
			Translate_Earbuds: "翻訳イヤホン",
			Shop_All_Headphones: "すべてのヘッドホンを見る",
			FILTERING: "フィルタリング"
		},
		WATCHES: {
			Shop_All_Watches: "すべての時計を見る"
		},
		SPEAKERS: {
			Shop_All_Speakers: "すべてのスピーカーを見る"
		},
		SUPPORT: {
			SERVICES: "サービス",
			Support_Center: "サポートセンター",
			Process_Warranty: "保証の処理",
			Order_Tracker: "注文トラッカー",
			Privacy_Center: "プライバシーセンター",
			Contact_Us: "お問い合わせ",
			FAQs: "よくある質問",
			Support_Videos: "サポートビデオ",
			Manuals: "マニュアル",
			Warranty_Info: "保証情報"
		},
		EXPLORE: {
			ACTIVITIES: "アクティビティ",
			CES_2026: "CES 2026",
			CES_2025: "CES 2025",
			CES_2024: "CES 2024",
			NC20_Available: "NC20 利用可能",
			NC20_Pro_Coming: "NC20 Pro 近日登場",
			TOZO_Coupon: "TOZOクーポン",
			BLACK_FRIDAY: "ブラックフライデー",
			CYBER_MONDAY: "サイバーマンデー",
			HOLIDAY_SALE: 'ホリデーセール',
			SOUND_DEALS: "サウンドディール",
			VALENTINE_S_DAY: "バレンタインデー",
			CHRISTMAS_SALE: "クリスマスセール",
			PROMOTION: "プロモーション",
			HOT_SALE: "ホットセール",
			Halloween_Sale: "ハロウィンセール",
			TOZOAiryEar: "TOZOエアリーイヤー",
			ST_PATRICK_S_DAY: "聖パトリックの日",
			SPRING_SALE: "春のセール",
			EASTER_SALE: "イースターセール",
			HT3_Coming_Soon: "HT3 近日公開",
			EARTH_DAY_SALE: "アースデーセール",
			MOTHERS_DAY_SALE: "母の日セール",
			FATHERS_DAY: "父の日",
			INDEPENDENCE_DAY: "独立記念日",
			PRIME_DAY: "プライムデー",
			SUMMER_SALE: "サマーセール",
			Back_To_School: "新学期セール",
			CLUB: "クラブ",
			Blog: "ブログ",
			Forum: "フォーラム",
			BRAND: "ブランド",
			Our_Story: "私たちのストーリー",
			Technology: "テクノロジー",
			TOZO_FOR_BUSINESS: "TOZO ビジネス向け",
			Dealer_Store: "販売店ストア",
			TOZO_Distrbutor_Portal: "TOZOディストリビューターポータル",
			Become_a_Distribution_Partner: "流通パートナーになる"
		},
		Account: {
			SIGN_IN: 'サインイン',
			My_account: 'マイアカウント',
			Sign_out: 'サインアウト',
		},
	},
	homePage: {
		banner: {
			Welcome: 'TOZOコミュニティへようこそ',
		},
		nav: {
			Home: 'ホーム',
			Followers_list: 'フォロワーリスト',
			Fans_list: 'ファンリスト',
			Personal: '個人',
			Messages: 'メッセージ',
		},
	},
	postsArr: {
		Recommand: 'おすすめ',
		Following: 'フォロー中',
		Say_something: '何か言いますか？',
		Submit: '送信',
		Follow: 'フォロー',
		Not_interested: '興味がない',
		Don_t_like_the_author: '作者が好きではない',
		Report: '報告',
		Cancel: 'キャンセル',
		Pin: 'ピン',
		Unpin: 'ピンを外す',
		Delete: '削除',
		Cancel: 'キャンセル',
	},
	FollowersArr: {
		Followers: 'フォロワー',
		Search_for_followers: 'フォロワーを検索',
	},
	FansArr: {
		Fans: 'ファン',
		Search_for_fans: 'ファンを検索'
	},
	PersonalArr: {
		Likes: 'いいね',
		Followers: 'フォロワー',
		Fans: 'ファン',
		Posts: '投稿',
		Media: 'メディア',
		Edit: '編集',
	},
	MessagesArr: {
		Comment: 'コメント',
		Likes: 'いいね',
		New_Fans: '新しいファン',
		Comment_you: 'あなたにコメントしました',
		Liked_your_comment: 'あなたのコメントにいいねしました',
		Liked_your_post: 'あなたの投稿にいいねしました',
		Followed_you: 'あなたをフォローしました。',
		Comment_title: 'コメント',
		Reply_title: '返信',
		Reply: '返信',
		View: '表示',
		Replies_title: '返信',
		replies: '返信',
	},
	CommentList: {
		Heat: '人気',
		Time: '時間',
		Reply: '返信',
		Delete: '削除',
		Copy: 'コピー',
		Cancel: 'キャンセル',
	},
	SearchUserArr: {
		more_users: 'ユーザーのニックネームを入力してください',
		Who_to_follow: 'フォローする人',
	},
	postreportArr: {
		page_title: '報告',
		report_title: '報告の種類を選択してください',
		remark_placeholder: '具体的な問題をここに記述してください',
		select_report_type: '報告の種類を選択してください',
		remark_max_length: '問題の説明は500文字以内で記述してください。',
		validate_all: '必要な項目を確認してください',
		reportList: {
			Spam_and_Abuse: 'スパムと悪用',
			Pornographic: 'ポルノおよび不適切な内容',
			False_Information: '虚偽情報',
			Intellectual: '知的財産の侵害',
			Personal_safety: '個人の安全と脅威',
			Hate_Speech: '憎悪表現',
			suicide_content: '自傷または自殺内容',
			Account_theft: 'アカウント盗難または詐欺',
			Impersonating_someone_else: '他人になりすます',
			Harassment_Report: 'ハラスメント報告',
			Invasion_of_Privacy: 'プライバシーの侵害',
			Malware_or_links: 'マルウェアまたはリンク',
			Other: 'その他',
		},
	},
	EditPersonalInformation: {
		page_title: '個人情報の編集',
		placeholder: {
			nickname: 'ニックネームを入力してください',
			country: '国/地域を選択してください',
			gender: '性別を選択してください',
			year: '年を選択',
			month: '月を選択',
			date: '日を選択',
		},
		genderList: {
			male: '男性',
			female: '女性',
			other: 'その他',
		},
		rules: {
			nickname_required: 'ニックネームを入力してください',
			nickname_length: 'ニックネームは1〜50文字である必要があります',
			avatar_required: 'プロフィール写真をアップロードしてください',
			bg_img_required: 'ホームページの背景画像をアップロードしてください',
		},
	},
	ConfirmPrompt: {
		delete_tips: '削除してもよろしいですか？',
		Your_login: 'ログインが期限切れになりました。再度ログインしてください',
		experience_more: 'ログインして、もっと面白いことを体験してください',
		Login_Tips: 'ログインのヒント',
	},
	SwiperArr: {
		Live: 'ライブ',
	},
	tipsArr: {
		Send_successfully: '送信に成功しました',
		Feedback_success: 'フィードバックが成功しました',
		Edited_success: '編集が成功しました',
		Disliked_user: '嫌いなユーザーIDは空にできません',
		System_Error: 'システムエラー',
		reported_post: 'この投稿はすでに報告されています',
		user_info_required_fields: '必要な項目を確認して記入してください',
		network_request: 'ネットワークリクエストが存在しません',
	},
	buttonArr: {
		Submit: '送信',
		Follow: 'フォロー',
		Unfollow: '解除',
		Edit: '編集',
		Cancel: 'キャンセル',
		Confirm: '確認',
		Send: '送信',
		Save: '保存',
	},
	noDataArr: {
		interesting_things: 'もっと面白いことを体験するためにログインしてください',
		No_data_yet: 'まだデータがありません',
		follow_list: 'まだ誰もフォローしていません',
		fan_home_page: '面白いコンテンツを公開して、もっと多くの人を惹きつけましょう',
		message: 'メッセージデータがありません',
		comment_module: 'コメントデータがありません',
		likes_module: 'まだいいねデータがありません',
		comment_replies_list: 'コメント返信情報がありません',
		new_fan_follow_list: '新しいファンのデータがありません',
		search_user: '関連する推奨がありません',
		go_login: 'ログインへ',
	},
	timeArr: {
		Just_now: 'たった今',
		minute_ago: '分前',
		hour_ago: '時間前',
		Yesterday: '昨日',
		days_ago: '日前',
	},
	FileUploadArr: {
		image_formats: 'アップロードされた画像ファイル形式はのみサポートされています',
		image_size: 'アップロードされた画像サイズは以下を超えることはできません',
		image_max_text: '最大でアップロードできます',
		image_files: '画像ファイル',
	  
		video_formats: 'アップロードされたビデオファイル形式はのみサポートされています',
		video_size: 'アップロードされたビデオファイルサイズは以下を超えることはできません',
		video_max_text: '最大でアップロードできます',
		video_files: 'ビデオファイル',
	  
		avatar_image_formats: 'アップロードされたアバター画像ファイル形式はのみサポートされています',
		avatar_image_size: 'アップロードされたアバター画像の最大ファイルサイズは',
		avatar_max_text: '最大でアップロードできます',
		avatar_files: 'アバター画像ファイル。',
	  
		background_image_formats: 'アップロードされた背景画像ファイル形式はのみサポートされています',
		background_image_size: 'アップロードされた背景画像の最大ファイルサイズは',
		background_max_text: '最大でアップロードできます',
		background_files: '背景画像ファイル。',
	},
	loading: '読み込み中',

	...jaLocale
}

export default ja
